export default __webpack_public_path__ + "static/media/qr.ae4f9eca.svg";